<!-- 公告 -->
<template>
    <div v-if="componentsData.type == 3">
        <div
            class="bg-div"
            :style="
                componentsData.content.version
                    ? {
                          ...(componentsData.content.bg_color && {
                              backgroundColor: componentsData.content.bg_color,
                          }),
                          ...(componentsData.content.bg_img.picview &&
                              componentsData.content.bg_value && {
                                  backgroundImage: `url(${componentsData.content.bg_img.picview})`,
                              }),
                          padding: `${componentsData.content.paddingData.top}px ${componentsData.content.paddingData.left}px`,
                          margin: `${componentsData.content.marginData.top}px ${componentsData.content.marginData.left}px`,
                          borderRadius: `${componentsData.content.radiusData.top}px ${componentsData.content.radiusData.top}px ${componentsData.content.radiusData.bottom}px ${componentsData.content.radiusData.bottom}px`,
                      }
                    : {}
            "
        >
            <img
                class="content-img"
                :src="componentsData.content.imgs.picview"
            />
            <div
                class="content-txt"
                :style="`font-size: ${componentsData.content.size}px;color: ${componentsData.content.text_color};`"
            >
                {{ componentsData.content.text }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        componentsData: {
            type: Object,
            default: {},
        },
    },
    data() {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style scoped>
.bg-div {
    padding: 12px;
    display: flex;
    align-items: center;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
}
.content-img {
    margin: 0 6px 0 0;
    width: 30px;
    height: 30px;
}
.content-txt {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>